module.exports = __webpack_public_path__ + "static/media/piscadinha.8cd29848.svg";